import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../config';
const API_BASE_URL = config.apiViaCepUrl;
export const viaCepBaseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: headers => {
        return headers;
    },
});
export const viaCepApi = createApi({
    reducerPath: 'viaCepApi',
    baseQuery: viaCepBaseQuery,
    tagTypes: ['cep'],
    endpoints: () => ({}),
});
